import * as wishlistSelectors from './wishlist.selectors'

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MbWishlistSelectors = {
  ...wishlistSelectors
}
